import { envConfig } from "@configs/env";
import logger from "@utils/logger";
import { writePersistedPrefix } from "./persisted-prefix";
import { providersReady } from "./providers";
import { getActiveProvider } from "./registry";
import type { AnalyticsAnonymousContext, AnalyticsIdentifyContext } from "./types";

export async function identifyUser(context: AnalyticsIdentifyContext): Promise<void> {
  logger._console.log("[analytics] identifyUser", { memberId: context.member?.id });
  await providersReady;
  await getActiveProvider()?.identify(context);
}

export async function resetAnalyticsUser(): Promise<void> {
  logger._console.log("[analytics] resetAnalyticsUser");
  await providersReady;
  await getActiveProvider()?.reset();
}

export async function resetAnalyticsUserIfStale(): Promise<void> {
  await providersReady;
  const provider = getActiveProvider();
  if (provider?.isIdentified?.()) {
    logger._console.log("[analytics] resetAnalyticsUserIfStale: clearing stale identity");
    await provider.reset();
  }
}

export async function setAnalyticsPersonProperties(props: Record<string, unknown>): Promise<void> {
  await providersReady;
  await getActiveProvider()?.setPersonProperties(props);
}

export async function setAnonymousAnalyticsContext(context: AnalyticsAnonymousContext): Promise<void> {
  // Cache the prefix synchronously, before the dynamic-import barrier.
  // The cache is a parallel persistence channel: its freshness should
  // not depend on provider chunk readiness, provider success, or page
  // lifecycle between this call and the provider response.
  writePersistedPrefix(envConfig?.accountId, context.gamePrefix);
  await providersReady;
  await getActiveProvider()?.setAnonymousContext(context);
}
